module.exports = __webpack_public_path__ + "img/1.74d80b7c.png";